import { requireAuth } from '@tcap/data-router/utils/requireAuth';

export async function protectedLoader({ request }) {
    return await requireAuth(request);
}
